import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

export const wrapPageElement = ({ element }) => {
  return <ParallaxProvider>{element}</ParallaxProvider>;
};

export const onRouteUpdate = () => {
  if (process.env.NODE_ENV === 'production') {
    setTimeout(() => {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'gatsby-route-change',
      });
    }, 50);
  }
};
